module.exports = __webpack_public_path__ + "img/hero.b0bdf09a.jpg";